"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var worker = function worker() {
  var zeroPad = function zeroPad(value) {
    return value < 10 ? "0".concat(value) : value;
  };

  var countFunc = function countFunc() {
    var start = Date.now();
    setInterval(function () {
      var delta = (Date.now() - start) / 1000;
      var moduleDelta = delta % 3600;
      var hours = Math.floor(delta / 3600);
      var minutes = Math.floor(moduleDelta / 60);
      var seconds = Math.floor(moduleDelta % 60);
      var complete = '' + zeroPad(hours) + ':' + zeroPad(minutes) + ':' + zeroPad(seconds);
      postMessage({
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        complete: complete
      });
    }, 700);
  }; // eslint-disable-next-line no-restricted-globals


  self.onmessage = function () {
    countFunc();
  };
};

var _default = worker;
exports["default"] = _default;